// src/pages/InventoryCounting/components/ImportHistory.jsx
import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { getInventoryImports } from '../../../../api/inventoryCountingApi';

export default function ImportHistory({ refreshKey }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadImports = async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getInventoryImports();
      setData(result.rows || []);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          'Nie udało się pobrać historii importów.',
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadImports();
  }, [refreshKey]);

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Historia importów
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {loading ? (
        <CircularProgress />
      ) : (
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Typ</TableCell>
                <TableCell>Plik</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Rekordy</TableCell>
                <TableCell>Błąd</TableCell>
                <TableCell>Data importu</TableCell>
                <TableCell>Użytkownik</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.type}</TableCell>
                  <TableCell>{row.fileName}</TableCell>
                  <TableCell>
                    <Chip
                      size="small"
                      label={row.status}
                      color={
                        row.status === 'IMPORTED'
                          ? 'success'
                          : row.status === 'FAILED'
                          ? 'error'
                          : 'default'
                      }
                    />
                  </TableCell>
                  <TableCell>{row.rowsCount}</TableCell>
                  <TableCell>
                    {row.errorMessage ? (
                      <Typography
                        variant="body2"
                        color="error"
                        sx={{
                          maxWidth: 300,
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}
                        title={row.errorMessage}
                      >
                        {row.errorMessage}
                      </Typography>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                  <TableCell>
                    {row.importedAt
                      ? new Date(row.importedAt).toLocaleString('pl-PL')
                      : '-'}
                  </TableCell>
                  <TableCell>
                    {row.importedBy
                      ? `${row.importedBy.firstName} ${row.importedBy.lastName}`
                      : '-'}
                  </TableCell>
                </TableRow>
              ))}

              {!data.length && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Brak importów
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}
